import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { UserModel } from '../../types/User';
import { CellType } from '../../types/Common';
import ActionHeader from '../../components/UserManagement/ActionHeader';
import CustomTable from '../../components/UI/CustomTable';
import { getUsers } from '../../apis/user';
import CustomPagination from '../../components/UI/CustomPagination';
import './user.scss';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'mobileNumber',
    label: 'شماره موبایل',
    type: CellType.MOBILE,
  },
  {
    key: 'registrationDate',
    label: 'تاریخ ایجاد ',
    type: CellType.REGISTER_DATE,
  },
  {
    key: 'testId',
    label: 'مشاهده نتیجه آزمون',
    type: CellType.TEST,
  },
];

const UserManagement = () => {
  const [userSelected, setUserSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getAllUsers = (search?: string) => {
    setLoading(true);
    getUsers(currentPage, rowsPerPage, search)
      .then((res: any) => {
        const newUsers = res.data?.map((i: UserModel) => {
          return {
            ...i,
            id: i.userId,
          };
        });
        setUsers(newUsers || []);
        setTotalPages(res.pagination?.totalPages || 1);
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAllUsers();
  }, [currentPage, rowsPerPage]);

  return (
    <Box className='mainUserContainer'>
      <ActionHeader
        userSelected={userSelected}
        getAllUsers={getAllUsers}
        users={users}
        setUserSelected={setUserSelected}
      />

      <CustomTable
        rows={users}
        tableHead={tableHead}
        selected={userSelected}
        loading={loading}
        rowsIndex={totalPages === 1 ? 0 : rowsPerPage * (currentPage - 1)}
        setSelected={setUserSelected}
      />

      <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChangeCurrentPage={(page: number) => setCurrentPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage: number) => {
          if (currentPage !== 0) setCurrentPage(1);
          setRowsPerPage(rowsPerPage);
        }}
      />
    </Box>
  );
};

export default UserManagement;
